import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { db } from "../../../firebase";
import {
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { Eye, EyeOff } from "lucide-react";

// export default function CorporateLogin() {
//   const [formData, setFormData] = useState({
//     taxNumber: "",
//     password: "",
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [formStatus, setFormStatus] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setFormStatus("");
//     setLoading(true);

//     const { taxNumber, password } = formData;

//     if (!taxNumber || !password) {
//       setFormStatus("Lütfen tüm alanları doldurun.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const auth = getAuth();

//       // 🔐 AUTH GİRİŞİ (DİREKT VERGİ NO İLE)
//       const email = `${taxNumber}@company.local`;

//       const userCredential = await signInWithEmailAndPassword(
//         auth,
//         email,
//         password
//       );

//       const user = userCredential.user;

//       // 🔎 COMPANIES COLLECTION'DAN ŞİRKETİ BUL
//       const companiesRef = collection(db, "companies");
//       const q = query(
//         companiesRef,
//         where("taxInfo.taxNumber", "==", Number(taxNumber))
//       );

//       const snapshot = await getDocs(q);

//       if (snapshot.empty) {
//         setFormStatus("Şirket bilgisi bulunamadı.");
//         setLoading(false);
//         return;
//       }

//       const companyDoc = {
//         id: snapshot.docs[0].id,
//         ...snapshot.docs[0].data(),
//       };

//       // 💾 LOCAL STORAGE
//       localStorage.setItem(
//         "companyData",
//         JSON.stringify({
//           uid: user.uid,
//           companyId: companyDoc.id,
//           companyTitle: companyDoc.company_id,
//           companyType: companyDoc.taxInfo.companyType,
//           taxNumber: companyDoc.taxInfo.taxNumber,
//           email,
//         })
//       );

//       localStorage.setItem("loginTimestamp", Date.now().toString());

//       setFormStatus("Giriş başarılı! Yönlendiriliyorsunuz...");

//       setTimeout(() => {
//         window.location.href = "/dashboard_corporate";
//       }, 1000);
//     } catch (error) {
//       console.error("Login Error:", error);

//       if (error.code === "auth/wrong-password") {
//         setFormStatus("Şifre hatalı.");
//       } else if (error.code === "auth/user-not-found") {
//         setFormStatus("Bu vergi numarasına ait bir hesap bulunamadı.");
//       } else {
//         setFormStatus("Bir hata oluştu. Lütfen tekrar deneyin.");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getStatusStyle = () => ({
//     ...styles.status,
//     color: formStatus.includes("başarılı") ? "#2e7d32" : "#d32f2f",
//   });

export default function CorporateLogin() {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Sayfamız güncelleniyor en kısa sürede hizmetinizde olacak</h2>

        {/* <form onSubmit={handleSubmit} style={styles.form}> */}
          {/* Vergi No */}
          {/* <div style={styles.inputGroup}>
            <label style={styles.label}>Vergi Numarası</label>
            <input
              type="text"
              name="taxNumber"
              value={formData.taxNumber}
              onChange={handleChange}
              placeholder="Vergi Numaranız"
              style={styles.input}
              required
            />
          </div> */}

          {/* Şifre */}
          {/* <div style={styles.inputGroup}>
            <label style={styles.label}>Şifre</label>
            <div style={styles.passwordWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Şifrenizi girin"
                style={styles.input}
                required
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={styles.eyeIcon}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </span>
            </div>
          </div> */}

          {/* {formStatus && <p style={getStatusStyle()}>{formStatus}</p>} */}

          {/* <button
            type="submit"
            disabled={loading}
            style={{
              ...styles.button,
              backgroundColor: loading ? "#8ba3d9" : "#001E78",
            }}
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button> */}

          {/* <div style={styles.links}>
            <a href="/forgot_password_corporate" style={styles.link}>
              Şifremi Unuttum
            </a>
            <span style={{ color: "#bbb" }}>|</span>
            <a href="/signup_corporate" style={styles.link}>
              Hesap Oluştur
            </a>
          </div> */}
        {/* </form> */}
      </div>
    </div>
  );
}

/* === STYLES === */
const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 16,
    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: 420,
    padding: "45px 40px",
    textAlign: "center",
  },
  title: {
    fontSize: 26,
    fontWeight: 600,
    color: "#001E78",
    marginBottom: 28,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 22,
  },
  inputGroup: { textAlign: "left" },
  label: {
    fontSize: 14,
    marginBottom: 6,
    display: "block",
    fontWeight: 500,
    color: "#333",
  },
  input: {
    width: "93%",
    padding: "12px 14px",
    fontSize: 15,
    borderRadius: 8,
    border: "1px solid #ccc",
  },
  passwordWrapper: { position: "relative" },
  eyeIcon: {
    position: "absolute",
    right: 12,
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#555",
  },
  button: {
    width: "100%",
    padding: "13px 0",
    fontSize: 16,
    borderRadius: 8,
    border: "none",
    color: "#fff",
    cursor: "pointer",
  },
  status: {
    fontSize: 14,
    textAlign: "center",
    marginTop: -6,
    fontWeight: 500,
  },
  links: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    marginTop: 18,
  },
  link: {
    fontSize: 14,
    color: "#001E78",
    textDecoration: "none",
  },
};